import { Form } from "react-bootstrap";
import { toast } from "react-toastify";


export default function RenderUserCompanyFields(props) {
  return (
    <>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          <Form.Label htmlFor="company_name">
            Company Name:
            <span style={{ color: "red", margin: "0 4px" }}>*</span>
          </Form.Label>

          <Form.Control
            type="text"
            id="company_name"
            placeholder="Company Name"
            maxLength={100}
            value={props.company_name}
            onChange={(e) => {
              const value = e.target.value;

              // ❌ special character detected
              if (!/^[a-zA-Z0-9 ]*$/.test(value)) {
                toast.warning("Special characters are not allowed in company name", {
                  toastId: "company-name-special-char",
                });
                return;
              }

              props.set_company_name(value);
            }}
            required
          />
        </Form.Group>

        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="company_phone">Company phone:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
            <Form.Control
              type="tel"
              id="company_phone"
              placeholder="Company Phone(10-digit)"
              value={props.company_phone}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, '');
                if (value.length > 10) {
                  toast.warning("Phone number cannot be more than 10 digits");
                  return;
                }
                if (value.length <= 10) {
                  props.set_company_phone(value);
                }
              }}
              required
            />

            

        </Form.Group>
      </div>
      <div className="row">
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="company_address">Company Address:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            as="textarea"
            rows={3}
            id="company_address"
            placeholder="Company Address"
            maxLength={500}
            value={props.company_address}
            onChange={(e) => props.set_company_address(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="col-md-6 form-group">
          {/* {props.isEditMode && ( */}
            <Form.Label htmlFor="company_pincode">Company Pincode:<span style={{ color: "red", margin: "0 4px" }}>*</span></Form.Label>
          {/* )} */}
          <Form.Control
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            id="company_pincode"
            placeholder="Company Pincode (6-digits)"
            value={props.company_pincode}
            onChange={(e) => {
              const onlyDigits = e.target.value.replace(/\D/g, "");
              if (onlyDigits.length <= 6) {
                props.set_company_pincode(onlyDigits);
              }
            }}
            onPaste={(e) => {
              const pasted = e.clipboardData.getData("text").replace(/\D/g, "");
              e.preventDefault();
              props.set_company_pincode(pasted.slice(0, 6));
            }}
            required
          />
        </Form.Group>
      </div>

      {/* <div className="row">
        <Form.Group className="col-md-6 form-group">
          {props.isEditMode && (
            <Form.Label htmlFor="company_licence">Licence:</Form.Label>
          )}
          <Form.Control
            type="number"
            id="company_licence"
            placeholder="Company Licence"
            value={props.company_licence}
            onChange={(e) => props.set_company_licence(e.target.value)}
            required
          />
        </Form.Group>
      </div> */}
    </>
  );
}
